import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Tooltip from '@material-ui/core/Tooltip';
import Box from '@material-ui/core/Box';
import Slide from '@material-ui/core/Slide';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { makeStyles } from '@material-ui/core/styles';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Fab from '@material-ui/core/Fab';

const useStyles = makeStyles((theme) => ({
    main: {
        position: "fixed",
        right: theme.spacing(1),
        bottom: theme.spacing(1),
        zIndex: 99,
        "@media print": {
            display: "none !important"
        }
    },
    button: {
        border: "1px solid",
        padding: theme.spacing(0.5)
    },
    icon: {
        fontSize: "3em"
    }
}));

const ScrollToTop = function () {
    const classes = useStyles();
    const location = useLocation();

    const trigger = useScrollTrigger({ threshold: 1, disableHysteresis: true });

    const scroll = () => {
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        if (location.state && location.state.noScroll == true) {
            
        } else {
            scroll();
        }
    }, [location.pathname]);

    return (
        <Slide appear={false} direction="up" in={trigger}>
            <Box className={classes.main}>
                <Tooltip title="Scroll to top">
                    <Fab aria-label="scroll to top" color="primary" onClick={scroll} className={classes.button}>
                        <ExpandLessIcon className={classes.icon} />
                    </Fab>
                </Tooltip>
            </Box>
        </Slide>);
};

export default ScrollToTop;